"use strict";

var _classCallCheck = require("/drone/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/drone/src/node_modules/@babel/runtime/helpers/createClass.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PossibleStorages = void 0;

var Oidc = __importStar(require("oidc-client"));

var auth_ntp_1 = __importDefault(require("./auth.ntp"));

var AUTH_DOMAIN_STG = 'https://sso.buildstaging.com/oidc';
var AUTH_DOMAIN_PROD = 'https://sso.hotmart.com/oidc';
var APP_AUTH_ROUTE = "".concat(window.location.origin, "/auth");
var SILENT_REQUEST_MIN_TIMEOUT = 2000;
var SILENT_REQUEST_DEFAULT_TIMEOUT = 5000;

var strEndsWith = function strEndsWith(str, search) {
  var strLen = str.length;
  return str.substring(strLen - search.length, strLen) === search;
}; // Fix authorities when there is only one role and backend returns a string


var fixAuthorities = function fixAuthorities(user) {
  var _a, _b;

  if (!user) return user; //deep clone object

  var userCopy = JSON.parse(JSON.stringify(user));
  var authorities = (_b = (_a = userCopy === null || userCopy === void 0 ? void 0 : userCopy.profile) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.authorities;

  if (authorities && typeof authorities === 'string') {
    userCopy.profile.attributes.authorities = [authorities];
    userCopy.profile.authorities = [authorities];
  }

  user.profile = userCopy.profile;
  return user;
};

var PossibleStorages;

(function (PossibleStorages) {
  PossibleStorages["localStorage"] = "localStorage";
  PossibleStorages["inMemoryStorage"] = "inMemoryStorage";
  PossibleStorages["sessionStorage"] = "sessionStorage";
  PossibleStorages["default"] = "localStorage";
})(PossibleStorages = exports.PossibleStorages || (exports.PossibleStorages = {}));

var AuthService = /*#__PURE__*/function () {
  function AuthService(instanceParam) {
    _classCallCheck(this, AuthService);

    this._oidcClient = Oidc;
    this.isProd = strEndsWith(window.location.host, '.hotmart.com');
    var settings = {};
    var silentRequestTimeout = SILENT_REQUEST_DEFAULT_TIMEOUT;

    if (typeof instanceParam === 'string') {
      settings['client_id'] = instanceParam;
    } else if (instanceParam) {
      settings = instanceParam;
    }

    if (!settings['client_id']) {
      throw Error('Please provide a client id');
    }

    if (settings.env) {
      this.isProd = settings.env === 'production';
    }

    if (settings.silentRequestTimeout) {
      silentRequestTimeout = Math.max(settings.silentRequestTimeout, SILENT_REQUEST_MIN_TIMEOUT);
    }

    var defaultSetting = {
      authority: this.isProd ? AUTH_DOMAIN_PROD : AUTH_DOMAIN_STG,
      redirect_uri: "".concat(APP_AUTH_ROUTE, "/login"),
      popup_redirect_uri: "".concat(APP_AUTH_ROUTE, "/login"),
      silent_redirect_uri: "".concat(APP_AUTH_ROUTE, "/renew"),
      post_logout_redirect_uri: "".concat(APP_AUTH_ROUTE, "/logout"),
      popup_post_logout_redirect_uri: "".concat(APP_AUTH_ROUTE, "/logout"),
      automaticSilentRenew: true,
      scope: 'openid profile',
      response_type: 'code',
      popupWindowFeatures: 'location=no,toolbar=no,width=500,height=659,left=100,top=100',
      popupWindowTarget: 'cas-popup-window',
      clockService: new auth_ntp_1.default(this.isProd)
    };
    this.userManager = new Oidc.UserManager(Object.assign(Object.assign(Object.assign({}, defaultSetting), settings), {
      silentRequestTimeout: silentRequestTimeout,
      userStore: this.getStorage(settings.storeToUse),
      stateStore: this.getStorage(settings.storeToUse)
    }));
    Oidc.Log.logger = console;
  }

  _createClass(AuthService, [{
    key: "getStorage",
    value: function getStorage(storage) {
      var Storages = {
        localStorage: function (_localStorage) {
          function localStorage() {
            return _localStorage.apply(this, arguments);
          }

          localStorage.toString = function () {
            return _localStorage.toString();
          };

          return localStorage;
        }(function () {
          return localStorage;
        }),
        sessionStorage: function (_sessionStorage) {
          function sessionStorage() {
            return _sessionStorage.apply(this, arguments);
          }

          sessionStorage.toString = function () {
            return _sessionStorage.toString();
          };

          return sessionStorage;
        }(function () {
          return sessionStorage;
        }),
        inMemoryStorage: function inMemoryStorage() {
          return new Oidc.InMemoryWebStorage();
        }
      };
      var store = Storages[storage !== null && storage !== void 0 ? storage : 'localStorage']();
      return new Oidc.WebStorageStateStore({
        store: store
      });
    } // User methods

  }, {
    key: "getUser",
    value: function getUser() {
      return this.userManager.getUser().then(function (response) {
        return fixAuthorities(response);
      });
    }
  }, {
    key: "removeUser",
    value: function removeUser() {
      return this.userManager.removeUser();
    } // SignIn methods

  }, {
    key: "signinRedirect",
    value: function signinRedirect() {
      var _this$userManager;

      return (_this$userManager = this.userManager).signinRedirect.apply(_this$userManager, arguments);
    }
  }, {
    key: "signinPopup",
    value: function signinPopup() {
      var _this$userManager2;

      return (_this$userManager2 = this.userManager).signinPopup.apply(_this$userManager2, arguments);
    }
  }, {
    key: "signinSilent",
    value: function signinSilent() {
      var _this$userManager3;

      return (_this$userManager3 = this.userManager).signinSilent.apply(_this$userManager3, arguments);
    }
  }, {
    key: "signinCallback",
    value: function signinCallback() {
      var _this$userManager4,
          _this = this;

      var signInResponse;
      return (_this$userManager4 = this.userManager).signinCallback.apply(_this$userManager4, arguments).then(function (response) {
        signInResponse = response;
        return _this.userManager.clearStaleState();
      }).then(function () {
        return fixAuthorities(signInResponse);
      });
    } // SignOut methods

  }, {
    key: "signoutRedirect",
    value: function signoutRedirect() {
      var _this$userManager5;

      return (_this$userManager5 = this.userManager).signoutRedirect.apply(_this$userManager5, arguments);
    }
  }, {
    key: "signoutPopup",
    value: function signoutPopup() {
      var _this$userManager6;

      return (_this$userManager6 = this.userManager).signoutPopup.apply(_this$userManager6, arguments);
    }
  }, {
    key: "signoutCallback",
    value: function signoutCallback() {
      var _this$userManager7,
          _this2 = this;

      var signOutResponse;
      return (_this$userManager7 = this.userManager).signoutCallback.apply(_this$userManager7, arguments).then(function (response) {
        signOutResponse = response;
        return _this2.userManager.clearStaleState();
      }).then(function () {
        return signOutResponse;
      });
    }
  }]);

  return AuthService;
}();

exports.default = AuthService;